import apiBase from "../apiBase";

export default {
	authenticate(email, password) {
		const url = "api/person/login";
		return apiBase.post(url, { email, password });
	},
};
